"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldTypeDto = exports.FormTypeDto = exports.FormStateDto = void 0;
var FormStateDto;
(function (FormStateDto) {
    FormStateDto["DRAFT"] = "draft";
    FormStateDto["ENABLED"] = "enabled";
    FormStateDto["DISABLED"] = "disabled";
})(FormStateDto = exports.FormStateDto || (exports.FormStateDto = {}));
var FormTypeDto;
(function (FormTypeDto) {
    FormTypeDto["CUSTOM"] = "custom";
    FormTypeDto["REG"] = "reg";
    FormTypeDto["APPLICATION"] = "application";
    FormTypeDto["FEEDBACK"] = "feedback";
})(FormTypeDto = exports.FormTypeDto || (exports.FormTypeDto = {}));
var FormFieldTypeDto;
(function (FormFieldTypeDto) {
    FormFieldTypeDto["STRING"] = "string";
    FormFieldTypeDto["TEXT"] = "text";
    FormFieldTypeDto["EMAIL"] = "email";
    FormFieldTypeDto["URL"] = "url";
    FormFieldTypeDto["PHONE"] = "phone";
    FormFieldTypeDto["DATE"] = "date";
    FormFieldTypeDto["TIME"] = "time";
    FormFieldTypeDto["NUMBER"] = "number";
    FormFieldTypeDto["CHOICE"] = "choice";
    FormFieldTypeDto["CHECKBOX"] = "checkbox";
    FormFieldTypeDto["DROPDOWN"] = "dropdown";
})(FormFieldTypeDto = exports.FormFieldTypeDto || (exports.FormFieldTypeDto = {}));
